module.exports = __webpack_public_path__ + "img/@logo_crown.c8dcee3d.png";